import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Container, Row, Col } from "react-bootstrap"
import SignUpComponent from "../components/sign-up"

const VisibleAndVocalPage = ({ location }) => {
  return (
    <Layout>
      <SEO
        location={location}
        image="/images/visible-and-vocal.png"
        title="Visible & Vocal"
        description="On February 4th, 2021 POCAM presented Visible & Vocal - The Canadian BIPOC in Advertising and Marketing Study. View the presentation, and download the report here."
      />
      <section className="bg-dark text-white py-4 py-lg-5">
        <Container>
          <Row className="mb-4">
            <Col md="7">
              <h1 className="display-4 mb-3">Visible & Vocal</h1>
              <h2 className="mb-0">
                The Canadian advertising and marketing study <em>by</em> BIPOC professionals, <em>for</em> BIPOC professionals
              </h2>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="py-4 py-lg-5">
        <Container>
          <Row>
            <Col md="7">
              <h3>
                POCAM’s signature study for BIPOC professionals is back — and we want to hear from you.
              </h3>
              <br />
              <p className="lead">
                The Visible & Vocal 6 survey is now closed. Click below to view the survey results.
              </p>
              <a
                className="btn btn-primary btn-lg mt-3 mb-5"
                rel="noreferrer"
                href="/images/visible-and-vocal/VV6-V-04-22-2026-FINAL.pdf"
                target="_blank"
              >
                View Results
              </a>
              <p>
                Every year, Visible & Vocal captures the voices of Black, Indigenous and People of Colour (BIPOC) professionals working in Canada’s advertising and marketing industry. Launched in 2020, the same year POCAM was founded, the study has become a trusted benchmark for understanding systemic inequities and emerging trends affecting BIPOC professionals. 
              </p>
              <p>
                <strong>Last year’s findings were clear:</strong> While more of us are mentoring and lifting each other up, workplace bias, exclusion, and stalled DEI progress continue to hold too many of us back.
              </p>
              <p>
                Our voices matter because they reveal truths the industry often tries to overlook. When we share our stories, we turn everyday realities into data, and data into change.
              </p>
              <p>
                By participating in this completely anonymous survey, you help:
              </p>
              <ul>
                <li><strong>Illuminate the challenges</strong> of operating within a systematically white working environment.</li>
                <li><strong>Track progress</strong> on discrimination, career growth, and leadership representation.</li>
                <li><strong>Hold our industry accountable</strong> for advancing equity and inclusion.</li>
              </ul>
              <p><strong>Your voice matters. Make it count.</strong></p>
              <br />
              <h3>
                By the numbers
              </h3>
              <br />
              <p>
                The last edition of Visible & Vocal was conducted in 2024 and surveyed over 200 BIPOC professionals, revealing that:
              </p>
              <ul>
                <li>56% believed their employer was making positive steps to focus on inclusion and advancement of BIPOC professionals.</li>
                <li>88% needed to be on guard at their agency or place of employment.</li>
                <li>80% experienced microaggressions, 58% experienced racial discrimination, and 33% experienced racial harassment from a colleague.</li>
                <li>43% of workplaces hired BIPOC professionals in executive positions in the past 12 months.</li>
                <li>31% had a BIPOC mentor or sponsor at their agency or place of employment.</li>
              </ul>
            </Col>
            <Col md="1"></Col>
            <Col md="4">
              <p>
                <strong>Download previous Visible & Vocal reports:</strong>
              </p>
              <ul>
                <li><a href="/images/visible-and-vocal/VV6-V-04-22-2026-FINAL.pdf" rel="noreferrer" target="_blank">Visible & Vocal 6</a> (2025)</li>
                <li><a href="https://drive.google.com/file/d/16KdWeH0eCRzgJJrDVT-tdesBAi7Ws586/view?usp=sharing" rel="noreferrer" target="_blank">Visible & Vocal 5</a> (2024)</li>
                <li><a href="https://drive.google.com/file/d/1kGS3_X67Nld8mjgbZciTCvjB2eiKfYJO/view?usp=sharing" rel="noreferrer" target="_blank">Visible & Vocal 4</a> (2023)</li>
                <li><a href="https://drive.google.com/file/d/1rtBx4CyaE2Dfv1v8N2AR2xyfVHCf_Ves/view?usp=sharing" rel="noreferrer" target="_blank">Visible & Vocal 3</a> (2022)</li>
                <li><a href="https://drive.google.com/file/d/1ssT_mPNF634PPpsBiIiI8jnk1TLCO5Ro/view?usp=sharing" rel="noreferrer" target="_blank">Visible & Vocal 2</a> (2021)</li>
                <li><a href="https://drive.google.com/file/d/1FL_Qv7Y9TTNuW2e2BIGaVn4sk_MGSqHD/view?usp=sharing" rel="noreferrer" target="_blank">Visible & Vocal 1</a> (2020)</li>
              </ul>
              <br></br>
              <p>
                <strong>Questions?</strong>
              </p>
              <p>For more information about Visible & Vocal, contact:<br /><a href="mailto:steerco@wearepocam.ca">POCAM Steerco</a></p>
            </Col>
          </Row>
        </Container>
      </section>
      <SignUpComponent />
    </Layout>
  )
}

export default VisibleAndVocalPage
